module.exports = __webpack_public_path__ + "static/media/top-active-players-dark-icon.e22295c3.svg";